<template>
    <div class="decorfinder-wrapper">
        <div class="global-modal__content">
            <div class="global-modal__header" v-if="hasHeader()">
                <slot name="header"/>
            </div>
            <div class="global-modal__body">
                <slot name="body"/>
            </div>
            <div class="global-modal__pagination" v-if="hasPagination()">
                <slot name="pagination"/>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "decorfinder-wrapper",
    components: {},
    props: {
        fullscreen: {
            type: Boolean,
            default: false
        },
        lockScrolling: {
            type: Boolean,
            default: false
        },
        bgColorGray: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        hasHeader() {
            return !!this.$slots.header || !!this.$scopedSlots.header
        },
        hasPagination() {
            return !!this.$slots.pagination
        }
    }
}
</script>
